import { useTranslation } from 'react-i18next'
import { CalendarX2, Mail } from 'lucide-react'
import { motion } from 'framer-motion'
import { LocalizedLink } from '@/components/LocalizedLink'

const ease = [0.16, 1, 0.3, 1] as [number, number, number, number]

export function OpenDoorsPage() {
  const { t } = useTranslation('common')

  return (
    <>
      {/* 1. Intro Sweet Academy */}
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease }}
            className="text-center mb-14"
          >
            <span className="inline-flex items-center gap-3 text-brand font-heading font-medium tracking-wider uppercase text-sm mb-4">
              <span className="w-8 h-px bg-brand" />
              {t('openDoors.intro.label')}
              <span className="w-8 h-px bg-brand" />
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-neutral-900 mb-6">
              {t('openDoors.intro.title')}
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease }}
            className="max-w-4xl mx-auto"
          >
            <p className="text-lg md:text-xl text-neutral-600 leading-relaxed text-center">
              {t('openDoors.intro.description')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* 2. Eventi */}
      <section className="section-padding bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease }}
            className="text-center mb-14"
          >
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-neutral-900">
              {t('openDoors.events.title')}
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease }}
            className="max-w-2xl mx-auto text-center"
          >
            <div className="bg-white rounded-2xl p-10 md:p-14 shadow-sm">
              <div className="w-16 h-16 rounded-full bg-neutral-100 flex items-center justify-center mx-auto mb-6">
                <CalendarX2 className="w-8 h-8 text-neutral-400" />
              </div>
              <p className="text-lg text-neutral-600 mb-8">
                {t('openDoors.events.empty')}
              </p>
              <LocalizedLink
                to="contacts"
                className="inline-flex items-center gap-2 text-brand font-medium hover:text-brand-dark transition-colors"
              >
                <Mail className="w-5 h-5" />
                {t('openDoors.events.cta')}
              </LocalizedLink>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}
